/**
 * Names of Flash functions that can be called with Javascript from the embedding HTML page.
 *
 * Documentation:
 * https://docs.google.com/a/goodgamestudios.com/spreadsheet/ccc?key=0AtXFx56d9X1adDlYcUtZc3JVdThMQ0NES0pUYlFqMHc#gid=1
 *
 * TODO: Use these constants for all ExternalInterface.addCallback() usages in the client
 */
export class FlashCallbackFunctionName {
    public static FACEBOOK_LOGIN_CALLBACK: string = "fbLoginCallback";
    public static SHOW_PRE_PAYMENT_DIALOG: string = "showPrePaymentDialog";
    public static SET_LOGIN_KEYS: string = "setLoginKeys";
}

